import React from 'react'; // TODO: check this

var NavContext = /*#__PURE__*/React.createContext(null);
NavContext.displayName = 'NavContext';
export default NavContext;